// extracted by mini-css-extract-plugin
export var progressBar = "_kx-0";
export var progressBarInner = "_kx-1";